/**
 * Update Button Component
 * Handles rendering of update button with loading state
 */

import React from "react";
import Update from "../../../../../images/icons/upate-icon1.png";
import { CSS_CLASSES } from "../utils/cardBodyConstants.js";

/**
 * Update Button Component
 */
export const UpdateButton = ({
  isTimeInputActive,
  isUpdateLoading,
  uFormatedTimeError,
  uEndTimeError,
  uStartTimeError,
  className = "",
}) => {
  return (
    <div className={`${CSS_CLASSES.SET_BTN_OUTER} ${className}`}>
      {!isTimeInputActive && (
        <button
          type="submit"
          className={CSS_CLASSES.SET_BUTTON}
          disabled={
            !!(isUpdateLoading ||
              uFormatedTimeError ||
              uEndTimeError ||
              uStartTimeError ||
              isTimeInputActive)
          }
        >
          {isUpdateLoading ? (
            <div
              style={{
                width: "18px",
                height: "18px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          ) : (
            <img width="18" src={Update} alt="update" />
          )}
        </button>
      )}
      {/* Pulse animation style */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};
